import {
  ChannelEditScheduleGuard,
  ChannelEditSettingsGuard,
  ChannelViewGuard,
} from "./guards/channels-guard.guard";
import { UploadGraphicsComponent } from "./components/upload-graphics/upload-graphics";
import { SchedulerComponent } from "./components/scheduler/scheduler.component";
import { ExportRunLogComponent } from "./components/export-run-log/export-run-log";
import { CalendarComponent } from "./components/calendar/calendar.component";
import { ChannelsDashboardComponent } from "./components/channel/channels-dashboard/channels-dashboard.component";

import { AutopilotComponent } from "./components/autopilot/autopilot.component";
import { LiveComponent } from "./components/live/live.component";
import { ErrorComponent } from "./components/error/error.component";
import { ExportEpgComponent } from "./components/export-epg/export-epg";
import { BatchImportComponent } from "./components/batch-import/batch-import";
import { MediaEditorComponent } from "./components/mediaEditor/mediaEditor.component";
import { ChannelComponent } from "./components/channel/channel.component";
import { ChannelWizardComponent } from "./components/channel/channel-wizard/channel-wizard.component";
import { EditGraphicsComponent } from "./components/graphics/edit/edit-graphics.component";
import { AutopilotRuleWizardComponent } from "./components/autopilot/graphicsRuleWizard/autopilot-rule-wizard.component";
import { CleanSchedulerComponent } from "./components/clean-scheduler/clean-scheduler";
import { LiveFeedCreateEditComponent } from "./components/live/createEditLiveFeed/live-feed-create-edit.component";
import { UploadStatusReport } from "./components/uploads-report/uploads-report.component";
import { QualityCheckComponent } from "./components/quality-check/quality-check";
import { DynamicPromoCreateEditComponent } from "./components/dynamic-promo/dynamic-promo-create-edit";
import { TenantSettingsComponent } from "./components/tenant/tenant-settings.component";
import { UsersListComponent } from "./components/user/users-list/users-list.component";
import { AddNewUserComponent } from "./components/user/add-new-user/add-new-user.component";
import { EditUserComponent } from "./components/user/edit-user/edit-user.component";
import { TenantComponent } from "./components/tenant/tenant.component";
import { RequestDemoComponent } from "./components/tenant/request-demo/request-demo.component";
import { ChooseTemplateComponent } from "./components/tenant/choose-template/choose-template.component";
import { RequestDemoSuccessWindowComponent } from "./components/tenant/choose-template/success-window/success-window.component";
import { UsersComponent } from "./components/user/users/users.component";
import {
  BatchUploadGuard,
  ChannelCreatorGuard,
  ContentManagerGuard,
  LiveManagerGuard,
  MAMEditorGuard,
  MediaTranscoderGuard,
  SuperUserGuard,
  UsersManagerGuard,
} from "./guards/permission.guard";
import { ImportSegmentsCsvComponent } from "./components/import-segments-csv/import-segments-csv.component";
import { Routes } from "@angular/router";
import { LiveSourcesContainerComponent } from "./components/live-sources/live-sources-container/live-sources-container.component";
import { LiveOtherUserEnteredComponent } from "./components/live/live-other-user-entered/live-other-user-entered.component";

export const AppRoutes: Routes = [
  {
    path: "mam",
    component: SchedulerComponent,
    children: [
      {
        path: "editMedia/:mediaId",
        component: MediaEditorComponent,
        canActivate: [MAMEditorGuard],
      },
      { path: "uploadReport", component: UploadStatusReport },
      { path: "qualityCheck/:id", component: QualityCheckComponent },
      { path: "**", redirectTo: "mam/uploadReport" },
    ],
  },
  {
    path: "scheduler",
    canActivate: [ChannelViewGuard],
    component: SchedulerComponent,
    children: [
      { path: "calendar", component: CalendarComponent },
      /*{ path: 'editMedia/:mediaId', component: MediaEditorComponent , canActivate: [MAMEditorGuard]},*/
      { path: "graphics/new/:templateId", component: EditGraphicsComponent },
      { path: "graphics/edit/:graphicId", component: EditGraphicsComponent },
      { path: "graphics", component: EditGraphicsComponent },
      {
        path: "live",
        component: LiveFeedCreateEditComponent,
        canActivate: [SuperUserGuard],
      },
      {
        path: "live/edit/:id",
        component: LiveFeedCreateEditComponent,
        canActivate: [SuperUserGuard],
      },
      {
        path: "dynamicPromo",
        component: DynamicPromoCreateEditComponent,
        canActivate: [SuperUserGuard],
      },
      {
        path: "dynamicPromo/edit/:id",
        component: DynamicPromoCreateEditComponent,
        canActivate: [SuperUserGuard],
      },
      { path: "exportepg", component: ExportEpgComponent },
      { path: "exportrunlog", component: ExportRunLogComponent },
      { path: "cleanscheduler", component: CleanSchedulerComponent },
      { path: "import-segments", component: ImportSegmentsCsvComponent },
    ],
  },
  {
    path: "autopilot",
    component: AutopilotComponent,
    canActivate: [ChannelEditScheduleGuard],
    children: [
      { path: "new", component: AutopilotRuleWizardComponent },
      { path: "edit/:ruleId", component: AutopilotRuleWizardComponent },
      //            { path: 'graphics', redirectTo: '/autopilot/graphics/new', pathMatch: 'full' },
      { path: "", redirectTo: "/autopilot/new", pathMatch: "full" },
    ],
  },
  {
    path: "channels",
    component: ChannelComponent,
    children: [
      {
        path: "new",
        component: ChannelWizardComponent,
        canActivate: [ChannelCreatorGuard],
      },
      {
        path: "edit/:id",
        component: ChannelWizardComponent,
        canActivate: [ChannelEditSettingsGuard],
      },
      { path: "", component: ChannelsDashboardComponent },
    ],
  },
  {
    path: "other-user-entered-live-page",
    component: SchedulerComponent,
    canActivate: [LiveManagerGuard],
    children: [{ path: "", component: LiveOtherUserEnteredComponent }],
  },
  {
    path: "live",
    component: SchedulerComponent,
    canActivate: [LiveManagerGuard],
    children: [{ path: "", component: LiveComponent }],
  },
  {
    path: "tenant",
    component: TenantComponent,
    canActivate: [SuperUserGuard],
    children: [
      { path: "request-demo", component: RequestDemoComponent },
      { path: "choose-template", component: ChooseTemplateComponent },
      { path: "success-window", component: RequestDemoSuccessWindowComponent },
    ],
  },
  {
    path: "users",
    component: UsersComponent,
    canActivate: [UsersManagerGuard],
    children: [
      { path: "edit/:id", component: EditUserComponent },
      { path: "new", component: AddNewUserComponent },
      { path: "list", component: UsersListComponent },
      { path: "edit", redirectTo: "/users/list", pathMatch: "full" },
      { path: "", redirectTo: "/users/list", pathMatch: "full" },
    ],
  },
  { path: "error", component: ErrorComponent },

  {
    path: "uploadgraphics",
    component: UploadGraphicsComponent,
    canActivate: [SuperUserGuard],
  },
  {
    path: "batchimport",
    component: BatchImportComponent,
    canActivate: [BatchUploadGuard],
  },
  {
    path: "tenantsettings",
    component: TenantSettingsComponent,
    canActivate: [],
  },
  {
    path: "publishing-status",
    redirectTo: "clipping-studio",
    pathMatch: "full",
  },
  {
    path: "live-sources",
    component: LiveSourcesContainerComponent,
  },
  { path: "", redirectTo: "channels", pathMatch: "full" },
  { path: "exportepg", redirectTo: "scheduler/exportepg" },
  { path: "exportrunlog", redirectTo: "scheduler/exportrunlog" },
  { path: "cleanscheduler", redirectTo: "scheduler/cleanscheduler" },
  { path: "**", redirectTo: "channels" },
];
